import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { url } from 'src/app/config/config';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ImageConfigService {
  private logoSource = new BehaviorSubject<string>(url + "upload/logo.jpg");
  private logoDashboardSource = new BehaviorSubject<string>(url + "upload/logo.jpg");

  currentLogo = this.logoSource.asObservable();
  currentLogoDashboard = this.logoDashboardSource.asObservable();

  updateImages(userName: string) {
    console.log(userName);

    if (userName === undefined && environment.appName === 'campanaragricola'){
      this.logoSource.next(url + "upload/logo.jpg");
      this.logoDashboardSource.next(url + "upload/logo.jpg");
    }

    if (userName.localeCompare('Locatec') == 0) {
      this.logoSource.next(url + "upload/logo.jpg");
      this.logoDashboardSource.next(url + "upload/logo.jpg");
    } else if (userName.localeCompare('FNDB') == 0) {
      this.logoSource.next(url + "upload/logo-fndb.png");
      this.logoDashboardSource.next(url + "upload/logo-fndb.png");
    } else {
      this.logoSource.next(url + "upload/logo.jpg");
      this.logoDashboardSource.next(url + "upload/logo.jpg");
    }
  }
}
